import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { CourtSystemParams } from '@ftr/routing-paths'
import { FeatureFlagKeyOfType, LaunchDarklyService } from '@ftr/ui-feature-flags'
import { AuthenticationService } from '@ftr/ui-user'

export function makeFeatureFlagGuard(flagName: FeatureFlagKeyOfType<boolean>): CanActivateFn {
  return async route => {
    const launchDarklyService = inject(LaunchDarklyService)
    const authService = inject(AuthenticationService)
    const router = inject(Router)

    const courtSystemId = route.params[CourtSystemParams.CourtSystemId]

    const featureFlagEnabled = await launchDarklyService.getFlagVariationForUser(
      authService.currentUser!,
      flagName,
      courtSystemId,
    )
    if (!featureFlagEnabled) {
      return router.createUrlTree(['../'])
    }
    return true
  }
}

export function makePublicFeatureFlagGuard(flagName: FeatureFlagKeyOfType<boolean>): CanActivateFn {
  return async route => {
    const launchDarklyService = inject(LaunchDarklyService)
    const router = inject(Router)

    const courtSystemId = route.params[CourtSystemParams.CourtSystemId]

    const featureFlagEnabled = await launchDarklyService.getFlagVariationForAnonymous(flagName, courtSystemId)
    if (!featureFlagEnabled) {
      return router.createUrlTree(['../'])
    }
    return true
  }
}
